<template>
	<div tabindex="0" :style="extraStyle" id="TinyEditor" :class="customClass">
        <quill-editor
            v-model="text"
            ref="quill"
            :options="editorOptions"
            class="text-frame-editor"
            @focus="onFocus"
            @blur="onBlur"
            @change="onChange"
        />

		<div class="button-child-frame--container">
			<button
				v-b-tooltip.hover
				title="Configuração do texto"
				v-if="showSettings"
				class="button-child-frame button-setting-text mb-1"
				@click="() => $emit('openSettingsFrameChild')"
			>
				<i class="fal fa-cog fa-md"></i>
			</button>

			<button
				v-b-tooltip.hover
				title="Excluir texto"
				v-if="showSettings"
				class="button-child-frame button-delete-text"
				@click="() => $emit('deleteFrameChild')"
			>
				<i class="fal fa-trash-alt fa-md"></i>
			</button>
		</div>


		<b-modal
			id="textAiModal"
			ref="textAiModal"
			modalClass="full-white"
			title="Gerar texto com IA"
			size="md"
			centered
			hide-footer
		>
			<label>Escreva sobre o que vc quer que a uli gera o texto 🚀: </label>
			<div class="d-flex">
				<input type="text" ref="aitext" name="aitext" class="form form-control" placeholder="texto sobre...">
				<button class="btn btn-primary ml-2" v-on:click="getAi">Gerar</button>
			</div>
		</b-modal>
	</div>
</template>
<script>
import axios from "axios";
import Loading from "@/components/Loading.vue";
import { mapGetters } from "vuex";
import { quillEditor } from "vue-quill-editor";
import Quill from "quill";

import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"

// const icons = Quill.import("ui/icons");
// icons["ia"] = `
// <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
//   <!-- Letra I -->
//   <line x1="7" y1="7" x2="7" y2="17"/>
//   <circle cx="7" cy="6" r="0.5" fill="currentColor"/>
//   <circle cx="7" cy="18" r="0.5" fill="currentColor"/>
//   <!-- Letra A -->
//   <path d="M14 17 L18 7 L22 17 Z"/>
//   <line x1="15.5" y1="13" x2="20.5" y2="13"/>
// </svg>`;



export default {
	name: "TinyEditor",
    components: {
        'quill-editor': quillEditor,
    },
	data() {
		return {
			valueExtra: this.extra || {},
			text: this.textContent || '',
			open:false,
			siteid: null,
			editorOptions : {
  				inline: this.inline,
				placeholder: this.placeholder,
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],
                            [{ header: [1, 2, 3, 4, 5, 6, false] }],
                            [{ align: [] }],
                            [
                                { color: [
                                    '#000000', '#e60000', '#ff9900', '#ffff00', '#008a00',
                                    '#0066ff', '#9933ff', '#ffffff', '#facccc', '#ffebcc',
                                    '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb',
                                    '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0',
                                    '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200',
                                    '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000',
                                    '#663d00', '#666600', '#003700', '#002966', '#3d1466',
                                ] },
                                { background: [] }
                            ],
                            ['link', 'image'],
                            [{ list: 'ordered' }, { list: 'bullet' }],
                            ['blockquote', 'code-block'],
                            ['clean'],
                            // ['ia']
                        ],
                        // handlers: {
                        //         ia: () => {
                        //             this.$refs.textAiModal.show();
                        //         }
                        //     }
                    },
                },
                    theme: 'snow',
				// comentado pq nao pode por margin bottom 0 em toda linha, linhas vazias ficam perdidas
				// no editor
                // forced_root_block_attrs: {
                //     'style': 'margin-bottom: 0', //adiciona stile line aos <p>
                // },
			},
			props: {
				component: { type: Array, default: () => [] },
				textAiModal: {
			      type: Boolean,
			      required: true,
			      default: false,
			    }
			},
		};
	},
	props: {
		textContent: {
			type: String,
		},
		frameId: {
			type: Number,
			required: false,
		},
		frameType: {
			type: String,
			required: false,
		},
		hasImageBackground: {
			type: Boolean,
			default: false,
		},
		extra : {
			type: Object,
			required: false,
		},
		customClass: {
			type: String,
			required: false,
		},
		heightEditor: {
			type: Number,
			required: false,
			default: 250
		},
		placeholder: {
			type: String,
			required: false,
			default: 'Escreva seu texto aqui...'
		},
		inline: {
			type: Boolean,
			required: false,
			default: true
		},
		showSettings: {
			type: Boolean,
			default: false
		},
		defaultColors: {
            type: Object | null,
			required: false,
            default: null,
        },
	},
	watch:{
		text(){
			this.$emit("contentText", this.text);
		}
	},
	computed: {
		...mapGetters("dashboardModule", ["getAllPages","getAllPosts","getSiteCss"]),
		extraStyle() {
            let style = {...this.valueExtra.style};

            style = {
                ...this.valueExtra.style,
            }

            if (!style.color && this.defaultColors && (this.defaultColors.colorDefault || this.defaultColors.colorInverted)) {
                style.color = this.hasImageBackground ? this.defaultColors.colorInverted : this.defaultColors.colorDefault;
            }

            return style;
        }
	},
	methods : {
        onFocus(e) {
            this.$emit("tinyFocus", e)
        },
        onBlur(e) {
            this.$emit("tinyBlur", e)
        },
        onChange({ html }) {
            this.$emit("tinyKeyup", html)
        },
		async getAi() {
			if (this.$refs.aitext.value == '') {
				return;
			}
			this.$refs.textAiModal.hide();

			// @deprecated
			// versao api php
			//this.$store.dispatch("dashboardModule/TOGGLE_LOADING", [true]);
			// await axios({
		    //     method: "post",
		    //     url: `${process.env.ROOT_API}/api/ai/text`,
		    //     data: {
		    //       text: this.$refs.aitext.value
		    //     },
		    //     headers: {
		    //       Authorization: "Bearer " + this.$session.get("jwt"),
		    //     }
	      	// })
	      	// .then(response => {
		    //   for(var key in response.data) {
		    //   	console.log(response.data[key])
		    //     //this.pets.push(response.data[key]);  //row by row
		    //     this.text = this.text != '' ? this.text + response.data[key] : response.data[key];
		    //   }
		    // })
			// .then((result) => {
			// 	console.log(result)

			/* busca fazer o stream dos dados via api
			ref: https://developer.mozilla.org/en-US/docs/Web/API/Server-sent_events/Using_server-sent_events#event_stream_format
			*/
			//
			const evtSource = new EventSource(process.env.AI_API + 'api/textComplete?prompt=' + this.$refs.aitext.value);

			evtSource.onopen = function() {
				console.log("Connection to server opened.");
			};

			var that = this;

			evtSource.onmessage = function(e) {
				var textai = e.data

				var lastTag = that.text.substr(that.text.length - 3); // => "checar se <p>"

				// se nao tiver texto ainda, ou a ultima tag for um <p> no texto do editor
				// nao criar outra quebra de linha
				if (lastTag == '<p>' || lastTag == '') {
					var textai = e.data.replace("<br />", "");
				} else {
					var textai = e.data.replace("<br />", "</p><p>");
				}

				that.text = that.text != '' ? that.text + '' + textai : textai;
			};

			evtSource.onerror = function() {
				console.log("EventSource failed.");
				evtSource.close();
			};
		},
	},
};
</script>

<style>
	.tox-editor-header.tox-statusbar.tox-tinymce:focus{
		border: none !important;
		visibility: hidden !important;
	}
	.tox.tox-tinymce{
		border: none!important;
		/* left: 50% !important;
		transform: translateX(-50%); */
		z-index:15;
	}
	.tox-editor-container{
		max-width: 1290px !important;
	}
	/* placeholder */
	.mce-content-body:not([dir=rtl])[data-mce-placeholder]:not(.mce-visualblocks)::before {
    	left: 10px !important;
	}
	.mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before{
		color: rgb(185 185 185 / 68%) !important;
	}

	/*
	Feito dessa forma pra tentar fazer o texto e o editor, entender sempre que cada p, h2.. ocupa uma linha inteira
	Estava dando problema, pq ficava margin-bottom: 0 e cada linha nao tinha um tamanho, criando varias linhas e criando varios elementos para tentar dar espaço
	Agora o problema é principalemnte pq na api-uli-v1, ele remove o <p><br></p> que fica no editor (pq acaba dando 2 espaços, o do margin-bottom do p e o espaço do <br>)
	E no editor vc ve com um espaço, mas na hora que salva ele troca, entao no site-client fica diferente.
	*/
	.mce-content-body p,
	.mce-content-body h1,
	.mce-content-body h2,
	.mce-content-body h3,
	.mce-content-body h4,
	.mce-content-body h5,
	.mce-content-body h6,
	.mce-content-body hr,
	.mce-content-body {
		width: 100%;
		float: left;
	}

	/* espaçamento do browser para lista.
	Precisa ter igual no site-client-v1 se mexer aqui */
	.mce-content-body ol, .mce-content-body ul {
		padding-inline-start: 20px;
	}

	#TinyEditor .button-child-frame--container {
		position: absolute;
		top: 0;
		bottom: 0;
		right: -12px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	#TinyEditor .button-child-frame {
		border: 1px solid #dddddd;
		background-color: #fff;
		color: #222;
		cursor: pointer;
		min-width: 26px;
		width: 26px;
		height: 26px;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	#TinyEditor .button-child-frame:hover {
		background-color: var(--main-color);
		border: 1px solid var(--main-color);
		color: #fff;
	}

	#TinyEditor .button-child-frame {
		opacity: 0;
		transition: all 300ms ease-in-out;
	}

	#TinyEditor:hover .button-child-frame {
		opacity: 1;
		transition: all 300ms ease-in-out;
	}

    .ql-ia {
        display: flex!important;
        justify-content: center;
        align-items: center;
    }

</style>



// WEBPACK FOOTER //
// src/components/organisms/TinyEditor.vue